export const TITLE = "BENCHASIRI\nPARK"

export const DESCRIPTION = `Benchasiri Park is located on Sukhumvit Road near Soi 24. It was built to commemorate the 60th birthday of HM Queen Sirikit in 1992. The park features a huge sculpture of a commemorative coin illustrating an image of HM Queen Sirikit, as well as 12 pieces of contemporary sculptures, including children's works.`
